import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav
      aria-label="面包屑导航"
      className="flex flex-wrap items-center gap-1 text-xs md:text-sm text-foreground-500"
    >
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-1">
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 font-label font-bold whitespace-nowrap">
              {item.label}
            </span>
          )}
          {index < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
          )}
        </span>
      ))}
    </nav>
  );
}